
import { types, actions } from './requests'
export const DOASSIGNDUPLICATES_TYPES = {
    ...types('DOASSIGNDUPLICATES'),
}
export const DOASSIGNDUPLICATES_ACTIONS = {
    ...actions('DOASSIGNDUPLICATES'),
}